<template>

  <div>
    <div class="explore" v-if="isPC">
      <div class="banner">
        <oss-img src="https://img.kakaclo.com/web-img/index/exploreBanner2.jpg" :width="700" :height="117" />
      </div>
      <div class="left" :class="{ leftFixed: leftFixed }">
        <!-- <div class="navigation f--c">
          <span class="pointer" @click="$router.replace('/mall')">Home</span>
          <i class="iconfont icon-a-arrow-left-s-line2"></i>
          <span style="color:#8B93A3;">Explore</span>
        </div> -->
        <div class="bg-white left-menu" style="float:left">
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.Area') }}</h1>
            <el-checkbox-group v-model="listForm.searchTags" @change="handleAreaChange">
              <div v-for="(item,index) in shortArea" :key="index">
                <el-checkbox :label="item.code">{{upperFirst(item.value)}}</el-checkbox>
              </div>
            </el-checkbox-group>
            <div class="view-more pointer" @click="openAreaDialog">{{ $t('Index.Explore.ViewMore') }}</div>
          </div>
          <!-- <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.ReleaseTime') }}</h1>
            <el-radio-group v-model="blogTime" size="medium ">
              <el-radio v-for="(item,index) in releaseTime" :key="index" :label="item.start" @change="value=>handleTimeChange(value,item)">{{item.text}} </el-radio><br>
            </el-radio-group>
          </div> -->
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.Category') }}</h1>
            <div class="view-more" @click="opencategoryDialog">{{ $t('Index.Explore.ViewMore') }}</div>
          </div>
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.Followers') }}</h1>
            <div style="height:40px">
              <el-input style="width:80px;height:30px;" v-model="fansStart" @change="value=>changeFans(value,1)"></el-input><span style="width:20px;text-align:center"> - </span>
              <el-input v-model="fansEnd" style="width:80px;height:30px;" @change="value=>changeFans(value,2)"></el-input>K
            </div>
            <div>
              <el-radio-group v-model="fansNumber" size="medium ">
                <el-radio v-for="(item,index) in fans" :key="index" :label="item.start" @change="value=>handleFansChange(value,item)">{{item.text}} </el-radio><br>
              </el-radio-group>
            </div>
          </div>
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.DesignElements') }}</h1>
            <div class="view-more" @click="openElementDialog">{{ $t('Index.Explore.ViewMore') }}</div>
          </div>
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.Color') }}</h1>
            <div class="view-more" @click="openColorDialog">{{ $t('Index.Explore.ViewMore') }}</div>
          </div>
          <div class="menu-item">
            <h1 class="menu-item-title">{{ $t('Index.Explore.Style') }}</h1>
            <el-checkbox-group v-model="listForm.searchTags" @change="handleStyleChange">
              <p v-for="(item,index) in shortStyle" :key="index">
                <el-checkbox :label="item.code">{{upperFirst(item.value)}}</el-checkbox>
              </p>
            </el-checkbox-group>
            <div class="view-more" @click="openStyleDialog">{{ $t('Index.Explore.ViewMore') }}</div>
          </div>
        </div>
      </div>
      <div class="login-cover f-c-c" v-show="isShow">
        <div>
          <p>{{ $t('Index.Explore.Tips1') }}</p>
          <div class="f-c-c">
            <el-button type="success" style="width:99px;height:44px;border-radius:30px;" @click="$router.push('/login')">{{ $t('Index.Explore.Login') }}</el-button>
          </div>
        </div>
      </div>

      <div class="container">
        <!-- login -->
        <!-- <div class="register-tip f--c" v-if="!$store.state.common.token">
          <img src="@/assets/img/icon/ExclamationCircle.svg" style="margin-right:10px" alt="">
          {{ $t('Index.Explore.Tips2') }}, <span style="color:#99C41C;" class="pointer" @click="jump('/register', 539)">&nbsp;{{ $t('Index.Explore.SignUp') }} &nbsp;</span> {{ $t('Index.Explore.Or') }} <span class="pointer" @click="jump('/login', 540)" style="color:#99C41C;"> &nbsp;{{ $t('Index.Explore.LogIn') }}&nbsp;</span> {{ $t('Index.Explore.Tips3') }}
        </div> -->
        <div class="filter-box">
          <div v-if="listForm.searchTags.length<8">
            <el-tag v-if="timetext!==''" class="filter-tag" type="info" closable @close="closeTimeTag">{{timetext}}</el-tag>
            <el-tag v-if="fanstext!==''" class="filter-tag" type="info" closable @close="closeFansTag">{{fanstext}}</el-tag>
            <el-tag class="filter-tag" type="info" closable v-for="(item,index) in listForm.searchTags" @close="closeTag(item)" :key="index">{{getValue(item)}}</el-tag>
          </div>
          <el-popover v-else placement="bottom-start" trigger="hover">
            <el-tag v-if="timetext!==''" style="margin-bottom:15px;margin-right:12px; background:#fff" type="info" closable @close="closeTimeTag">{{timetext}}</el-tag>
            <el-tag v-if="fanstext!==''" style="margin-bottom:15px;margin-right:12px; background:#fff" type="info" closable @close="closeFansTag">{{fanstext}}</el-tag>
            <el-tag style="margin-bottom:15px;margin-right:12px; background:#fff" type="info" closable v-for="(item,index) in listForm.searchTags" @close="closeTag(item)" :key="index">{{getValue(item)}}</el-tag>
            <p class="clear-all pointer" @click="closeAll">{{ $t('Index.Explore.ClearAll') }}</p>
            <span slot="reference" class="pointer"><i class="iconfont icon-filter-3-line" style="display:inline-block;margin-bottom:5px;"></i>{{ $t('Index.Explore.Filter') }}</span>
          </el-popover>
          <div class="sort-box">
            <span class="sort-type pointer" v-for="(item,index) in sortType" :key="index" :class="[item.value===listForm.sortType?'sort-type-select':'']" @click="sortChange(item)">
              {{item.text}}
              <img v-show="item.value===listForm.sortType" :src="item.select_img" alt="" lazy class="icons" />
              <img v-show="item.value!==listForm.sortType" :src="item.img" alt="" lazy class="icons" />
            </span>
          </div>
        </div>
        <div class="box">
          <div class="container-water-fall" v-loading="listLoading">
            <!-- <view v-if="show_wf"> -->
            <waterfall :col="pcCol" :data="list" @scroll="scrollTo" @finish="finish" v-if="list.length>0">
              <template>
                <div class="ins-product"  v-for="(item,index) in list" :key="index" @click.stop="showDetail(item)" :class="{visibles: isVisibility}">
                  <div class="ins-inner kakaExposure" :data-exposure-blogid="item.blogId" data-exposure-location="exploreList">
                    <div class="ins-product-image demo-image__preview">
                      <!-- <img :src="item.detailUrls" alt="" /> -->
                      <oss-img :src="item.detailUrls" mType="lfit" :width="122" style="width:100%"></oss-img>
                      <div class="camera-normal">
                        <div style="height:29px;" class="f-c-c">
                          <i class="iconfont icon-photo" :title="$t('Index.Explore.UploadAPicture')" />
                        </div>
                      </div>
                      <div class="camera pointer" @click="e=>clickCamera(e,item)">
                        <div style="height:29px;" class="f-c-c">
                          <i class="iconfont icon-photo" :title="$t('Index.Explore.UploadAPicture')" /><span>&nbsp; {{ $t('Index.Explore.ShopSimilar') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="info">
                      <span class="avatar f--c pointer" @click="e=>openBlogUrl(e,item)">
                        <oss-img :src="item.headImg" :width="12" :height="12" class="head-img " style="border-radius:50%"></oss-img>
                        <span style="max-width:180px" class="ellipsis">{{item.bloggerName}}</span>
                        <oss-img src="https://img.kakaclo.com/web-img/index/ins_icon.png" :width="7" :height="7"></oss-img>
                      </span>
                      <div class="hot-info f-b-c fw-w">
                        <div>
                          <span class="color1">{{forMatNumber(item.fansNum)}} </span><span class="color2">&nbsp;{{ $t('Index.Explore.Following') }}</span>
                        </div>
                        <div>
                          <span class="color1"> <img src="@/assets/img/homePage/like.svg" alt="" lazy class="icons" />{{forMatNumber(item.likeNum)}}</span>
                          <span class="color1" style="margin-left:14px"><img src="@/assets/img/homePage/comment.svg" alt="" lazy class="icons" />{{forMatNumber(item.commentNum)}} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </waterfall>
            <div v-if="list.length===0&&!listLoading" class="fd-c f--c" style="margin-top:50px">
              <img src="@/assets/img/homePage/empty-data.svg" alt="" /><br>
              <p style="font-size: 14px;line-height: 21px;color: #747A87;text-align: center;">{{ $t('Index.Explore.SorryNoDataFound') }}</p>
            </div>
          </div>
        </div>
        <div class="login-cover f-c-c" v-if="isShow">
          <div>
            <p>{{ $t('Index.Explore.Tips1') }}</p>
            <div class="f-c-c">
              <el-button type="success" style="width:99px;height:44px;border-radius:30px;background:#99c41c;" @click="$router.push('/login')">{{ $t('Index.Explore.Login') }}</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 详情 -->
      <div class="drawer-parent" v-show="visible">
        <div class="bloger">
          <div class="avatar f">
            <oss-img :src="bloggerObj.headImg" :width="12" :height="12" style="border-radius:50%"></oss-img>
            <div class="info">
              <p class="name">{{bloggerObj.fullName}}<oss-img src="https://img.kakaclo.com/web-img/index/ins_icon.png" :width="7" :height="7"></oss-img>
              </p>
              <p class="follow">{{forMatNumber(bloggerObj.fansNum)}} <span style="color: #747A87;"> {{ $t('Index.Explore.Followers') }}</span></p>
            </div>
          </div>
          <div v-if="!showMore">
            <p class="product-name ellipsis2">{{insInfo.textContent}}</p>
            <span style="color:#99c41c" class="pointer" @click="showMore=true">{{ $t('Index.Explore.ViewMore') }}</span>
          </div>
          <div v-else>
            <p style="padding-bottom:5px">{{insInfo.textContent}}</p>
            <span style="color:#99c41c" class="pointer" @click="showMore=false">{{ $t('Index.Explore.PackUp') }}</span>
          </div>
          <div class="like-comment">
            <span class="color1"> <img src="@/assets/img/homePage/like.svg" alt="" lazy class="icons" />{{forMatNumber(insInfo.likeNum)}}</span>
            <span class="color1" style="margin-left:14px"><img src="@/assets/img/homePage/comment.svg" alt="" lazy class="icons" />{{forMatNumber(insInfo.commentNum)}} </span>
          </div>
          <p class="blog-time">{{bloggerObj.blogTime}}</p>
          <el-button type="primary" @click="clickDetailCamera" style="width:100%">
            <i class="iconfont icon-photo" :title="$t('Index.Explore.UploadAPicture')" /><span>&nbsp; {{ $t('Index.Explore.ShopSimilar') }}</span>
          </el-button>
        </div>
        <div class="cloth-detail">
          <h1>{{ $t('Index.Explore.ClothingElements') }}</h1>
          <div v-for="(item,index) in currentTagsGroup.boxLabelRetList" :key="index" class="elements">
            <div v-if="item.type1.length>0" class="elements-item f-b-c">
              <div class="category-title">
                <span v-for="(x,y) in item.type1" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type2.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Color') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type2" :key="y" style="display:inline-block;width:23px;height:23px;border-radius:50%" :style="{background:x.color}"></span>
              </div>
            </div>
            <div v-if="item.type3.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Pattern') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type3" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type4.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Material') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type4" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type5.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Material') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type5" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type8.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Excipients') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type8" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type11.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Style') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type11" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type12.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Gender') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type12" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
            <div v-if="item.type13.length>0" class="elements-item f-b-c">
              <h1>{{ $t('Index.Explore.Contour') }}</h1>
              <div class="element-item-right">
                <span v-for="(x,y) in item.type13" :key="y">{{upperFirst(getValue(x.tag))}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 品类弹窗 -->
      <el-dialog :title="$t('Index.Explore.Category')" :visible.sync="categoryVisible" width="1000px">
        <div v-for="(item,index) in category" :key="index" class="f category-item">
          <h1 class="category-title">{{item.value}}</h1>
          <div class="category-childlist">
            <el-checkbox-group v-model="listForm.searchTags" @change="handleCategoryChange">
              <el-checkbox v-for="(x,y) in item.childList" :label="x.code" :key="y">{{upperFirst(x.value)}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog()">{{ $t('Index.Explore.Cancel') }}</el-button>
          <el-button type="primary" @click="checkCategoryFilter">{{ $t('Index.Explore.Submit') }}</el-button>
        </div>
      </el-dialog>
      <!-- 地区筛选 -->
      <el-dialog :title="$t('Index.Explore.Area')" :visible.sync="areaVisible" width="1000px">
        <div class="area-box f fw-w">
          <span class="area-item" v-for="(item,index) in area" :key="index" :class="[listForm.searchTags.includes(item.code)?'active-area':'']" @click="selectArea(item.code,index)">{{upperFirst(item.value)}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog()">{{ $t('Index.Explore.Cancel') }}</el-button>
          <el-button type="primary" @click="checkAreaFilter">{{ $t('Index.Explore.Submit') }}</el-button>
        </div>
      </el-dialog>
      <!-- 颜色弹窗 -->
      <el-dialog :title="$t('Index.Explore.Colors')" :visible.sync="colorVisible" width="800px">
        <div class="color-system-box f-c">
          <div v-for="(item,index) in colors" :key="index" class="f fd-c color-item">
            <div @mouseenter="colorMouseup(item.value,index)" :style="{background:item.code}" class="color-quart" :class="[item.value==='black and white gray'?'blackWhite':'',index===hoverIndex?'hover':'']"></div>
            <p v-show="index===hoverIndex">{{upperFirst(item.value)}}</p>
          </div>
        </div>
        <div class="color-system-child f fw-w">
          <div class="color-child f-c-c" v-for="(item,index) in currentColorSystem" :key="index">
            <div class="color-bar" :style="{background:item.code}" :class="[listForm.searchTags.includes(item.code)?'selectedColor':'']" @click="selectColorBar(item.code)"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog()">{{ $t('Index.Explore.Cancel') }}</el-button>
          <el-button type="primary" @click="checkColorFilter">{{ $t('Index.Explore.Submit') }}</el-button>
        </div>
      </el-dialog>
      <!-- 风格弹窗 -->
      <el-dialog :title="$t('Index.Explore.Style')" :visible.sync="styleVisible" width="1000px">
        <div class="style-box f-b-c fw-w">
          <el-checkbox-group v-model="listForm.searchTags" @change="handleStyleChange" class="f-b-c fw-w">
            <span class="style-item f--c" v-for="(item,index) in styles" :key="index">
              <el-checkbox :label="item.code">{{upperFirst(item.value)}}</el-checkbox>
            </span>
          </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog()">{{ $t('Index.Explore.Cancel') }}</el-button>
          <el-button type="primary" @click="checkStyleFilter">{{ $t('Index.Explore.Submit') }}</el-button>
        </div>
      </el-dialog>
      <!-- 设计要素 -->
      <el-dialog :title="$t('Index.Explore.DesignElements')" :visible.sync="designVisible" width="1000px">
        <div class="elements f" v-for="(item,index) in elements" :key="index">
          <h1 class="elements-title">{{upperFirst(item.value)}}</h1>
          <div>
            <span v-for="(x,y) in item.childList" :key="y" @click="e=>selectElement(e,item,x)">
              <el-popover :visible-arrow="true" placement="bottom-start" width="620" trigger="hover" v-if="x.childList.length>0">
                <div class="f fw-w">
                  <span v-for="(a,b) in x.childList" :key="b" class="inner-element pointer" :style="{color:item.active_tag===a.code? '#99C41C':''}" style="width:25%;" @click="e=>selectElement(e,item,a)">{{upperFirst(a.value)}}</span>
                </div>
                <span class="pointer element-tag" :class="[item.active_tag===x.code||item.active_parentCode===x.code?'active-area':'']" slot="reference" @click="e=>selectElement(e,item,x)">{{upperFirst(x.value)}}
                  <span v-if="item.active_value!==''&&item.active_parentCode===x.code">({{upperFirst(item.active_value)}})</span>
                </span>
              </el-popover>
              <span class="pointer element-tag" :class="[item.active_tag===x.code?'active-area':'']" v-else @click="e=>selectElement(e,item,x)">{{upperFirst(x.value)}}</span>
            </span>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeElementDialog()">{{ $t('Index.Explore.Cancel') }}</el-button>
          <el-button type="primary" @click="checkElementFilter">{{ $t('Index.Explore.Submit') }}</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="mobile-explore" v-else v-loading.fullscreen.lock="listLoading">

      <div class="mobile-filter-box f">
        <van-dropdown-menu style="flex:2">
          <!-- <van-dropdown-item :options="releaseTime" :title="timeValue" v-model="releaseTimeMobile" @change="value=>releaseTimeChangeMobile(value)"></van-dropdown-item> -->
          <van-dropdown-item :options="sortType" v-model="sortMobile" @change="value=>SortChangeMobile(value)"></van-dropdown-item>
        </van-dropdown-menu>
        <div class="filter" style="flex:1" @click="moreFilter = true">
          {{ $t('Index.Explore.Filter') }}
          <van-icon name="filter-o" />
        </div>
      </div>

      <div class="mobile-product" >
        <div v-if="!$store.state.common.userId && loginTop" class="login-top f-b-c">
          <div>{{ $t('Index.Explore.LoginExperience') }}</div>
          <div class="f--c">
            <el-button type="primary" @click="$router.push({path:'/login'})">{{$t('headerBar.login')}}</el-button>
            <div class="login-close f-c-c" @click="loginTop = false"><i class="iconfont icon-a-close-line1"></i></div>
          </div>
        </div>
        <div class="container-water-fall mobile-ins-product" v-if="list.length>0" >
          <waterfall :col="col" :data="list" @scroll="scrollTo" @finish="finish" >
            <template>
              <div class="cell-item" v-for="(item, index) in list" :key="index" @click.stop="jumpToDetail(item)">
                <div class="ins-inner kakaExposure" :data-exposure-blogid="item.blogId" data-exposure-location="exploreList">
                  <div class="ins-product-image">
                    <oss-img :src="item.detailUrls" mType="lfit" :width="175" style="width:100%"></oss-img>
                    <div class="mobile-header" @click="e=>openBlogUrl(e,item)">
                      <oss-img :src="item.headImg" :width="24" :height="24"></oss-img>
                    </div>
                  </div>
                  <div class="info">
                    <div class="hot-info">
                      <div class="info-top">
                        <span class="color1">{{forMatNumber(item.fansNum)}} </span><span class="color2">&nbsp;{{ $t('Index.Explore.Following') }}</span>
                      </div>
                      <div class="info-bottom">
                        <span class="color1"> <img src="@/assets/img/homePage/like.svg" alt="" lazy class="icons" />{{forMatNumber(item.likeNum)}}</span>
                        <span class="color1" style="margin-left:14px"><img src="@/assets/img/homePage/comment.svg" alt="" lazy class="icons" />{{forMatNumber(item.commentNum)}} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </waterfall>
        </div>
        <div v-if="list.length===0&&!listLoading" class="fd-c f--c" style="padding-top:2rem">
          <img src="@/assets/img/homePage/empty-data.svg" alt="" style="width:60%;text-align: center;" /><br>
          <p style="font-size: 14px;line-height: 21px;color: #747A87;text-align: center;">{{ $t('Index.Explore.SorryNoDataFound') }}</p>
        </div>
        <div class="mobile-login-cover f-c-c" v-show="isShow">
          <div>
            <p>{{ $t('Index.Explore.Tips1') }}</p>
            <div class="f-c-c">
              <el-button type="success" style="width:2rem;height:0.85rem;border-radius:8px;background:#99c41c;" @click="$router.push('/login')">{{ $t('Index.Explore.Login') }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="moreFilter" position="right" :style="{ width: '90%',height: '100%' }" closeable>
        <div class="mobile-filter-content">
          <div class="filter-box">
            <div class="mobile-filters ">
              <h1>{{ $t('Index.Explore.Area') }}</h1>
              <div class="f fw-w">
                <span class="filter-tag pointer" :class="[listForm.searchTags.includes(item.code)?'active-mobile-tag':'']" @click="addMobileFilterTag(item)" v-for="(item,index) in area" :key="index">{{upperFirst(item.value)}}</span>
              </div>
            </div>
            <div class="mobile-filters f fw-w">
              <h1>{{ $t('Index.Explore.Fans') }}</h1>
              <div class="f fw-w">
                <span class="filter-tag pointer" :class="[fansNumber===item.start?'active-mobile-tag':'']" v-for="(item,index) in fans" :key="index" @click="changeMobileFans(item)">{{item.text}}</span>
              </div>
            </div>
            <div class="mobile-filters f fw-w">
              <h1>{{ $t('Index.Explore.Style') }}</h1>
              <div class="f fw-w">
                <span class="filter-tag pointer" :class="[listForm.searchTags.includes(item.code)?'active-mobile-tag':'']" @click="addMobileFilterTag(item)" v-for="(item,index) in styles" :key="index">{{upperFirst(item.value)}}</span>
              </div>
            </div>
          </div>
          <div style="height:1.5rem"></div>
          <div class="btns f-b-c">
            <span class="clear-button" @click="clearAll">{{ $t('Index.Explore.ClearAll') }}</span>
            <el-button type="success" @click="submitMobileFilter">{{ $t('Index.Explore.Submit') }}</el-button>
          </div>
        </div>
      </van-popup>

    </div>
    <div style="width: calc(100vw - 350px);">
      <!-- <el-image-viewer style="position:absolute;left: 0;top: 0" ref="imageViwer" :initial-index="0" :on-switch="onSwitch" v-if="visible" :on-close="closeDrawer" :url-list="imgURL">
        <div>13123121</div>
        </el-image-viewer> -->
      <ImageViwer style="width:100%" ref="imageViwer" :initial-index="0" :on-switch="onSwitch" v-if="visible" :on-close="closeDrawer" :url-list="imgURL" />
    </div>
    <!-- 返回顶部 -->
    <el-backtop :bottom="190" :right="6" class="backtop">
      <img style="width:70px;height:70px" src="@/assets/img/homePage/backtop.png" alt="" />
    </el-backtop>
  </div>
</template>

<script>
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'

import ImageViwer from './components/ImageViwer.vue'

// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { depthTraversal } from '@/util/tree'
import API from '@/api'

import _ from 'lodash'
import { dateFormat } from '@/util/date'
import OssImg from '../../components/OssImg.vue'
const fans = [
  {
    text: 'Over 1M',
    start: 1000000,
    end: '',
    checked: false
  }, {
    text: '500K-5000K',
    start: 500000,
    end: 5000000,
    checked: false
  }, {
    text: '200k-500k',
    start: 200000,
    end: 500000,
    checked: false
  }, {
    text: '100K-200K',
    start: 100000,
    end: 200000,
    checked: false
  }, {
    text: '50K-100K',
    start: 50000,
    end: 100000,
    checked: false
  }

]
const releaseTime = [
  {
    text: 'Yesterday',
    value: 1,
    start: new Date() - 1 * 24 * 3600 * 1000,
    end: new Date()
  }, {
    text: 'Last seven days',
    value: 2,
    start: new Date() - 7 * 24 * 3600 * 1000,
    end: new Date()
  }, {
    text: 'Last 15 days',
    value: 3,
    start: new Date() - 15 * 24 * 3600 * 1000,
    end: new Date()
  }, {
    text: 'Last 30 days',
    value: 4,
    start: new Date() - 30 * 24 * 3600 * 1000,
    end: new Date()
  }
]
const sortType = [
  {
    value: 5,
    text: 'Choice',
    img: require('@/assets/img/icon/choice.svg'),
    select_img: require('@/assets/img/icon/choice copy.svg'),
    code: 37
  }, {
    value: 1,
    text: 'Latest release',
    img: require('@/assets/img/icon/latest_release.svg'),
    select_img: require('@/assets/img/icon/latest_release copy.svg'),
    code: 34
  }, {
    value: 3,
    text: 'Most liked',
    img: require('@/assets/img/icon/most_like.svg'),
    select_img: require('@/assets/img/icon/most_like copy.svg'),
    code: 35
  }, {
    value: 4,
    text: 'Most commented',
    img: require('@/assets/img/icon/most_comment.svg'),
    select_img: require('@/assets/img/icon/most_comment copy.svg'),
    code: 36
  }
]
export default {
  metaInfo: {
    title: 'Trends Capture by AI',
    meta: [
      {
        name: 'description',
        content: 'Tailor-made AI data services. Bringing you the content you desire, be it brands, fashion shows, marketplaces, or any other preferences you have.'
      }
    ]
  },
  components: {
    // OssImg,
    // ElImageViewer,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-popup': popup,
    'van-icon': icon,
    ImageViwer,
    OssImg
  },
  data() {
    return {
      releaseTime,
      fans,
      sortType,
      col: 2,
      show_wf: true,
      loginTop: true,
      listLoading: true,
      pcCol: 4,
      scrollTop: 0, // 储存滚动位置
      moreFilter: false,
      showMore: false,
      listForm: {
        pageNumber: 1,
        pageSize: 20,
        searchTags: [],
        sortType: 5,
        sortDirection: 'DESC'
        // blogTimeStart: '',
        // blogTimeEnd: '',
        // fansNumStart: undefined,
        // fansNumEnd: undefined
      },
      releaseTimeMobile: '',
      timeValue: 'Release Time',
      sortMobile: 5,
      blogTime: '',
      fansNumber: '',
      timetext: '',
      fanstext: '',
      fansStart: '',
      fansEnd: '',
      imgURL: [],
      visible: false,
      isVisibility: false,
      list: [],
      isShow: false,
      categoryVisible: false,
      totalPage: undefined,
      drawer: false,
      areaVisible: false,
      designVisible: false,
      colorVisible: false,
      styleVisible: false,
      insInfo: {},
      bloggerObj: {},
      deepMenu: [],
      menuList: [],
      currentTagsGroup: {},
      imgBlogList: [],
      activeNames: ['1'],
      category: [], // 品类筛选条件
      styles: [], // 风格筛选条件
      shortStyle: [],
      area: [],
      shortArea: [],
      colors: [],
      copyOldElementValue: [], // 元素值备份
      oldSearchTags: [], // 参数备份
      currentColorSystem: [], // 当前色系色值
      elements: [], // 设计要素
      selectColor: '', // 当前选中的色值
      oldSelectColor: '', // 之前选中的色值
      hoverIndex: undefined, // 当前悬浮色系色块
      areaCode: undefined, // 当前选中国家
      selectCategorys: [], // 选中的品类
      leftFixed: false // 左侧固定菜单栏
    }
  },
  created() {
    this.getInsList()
    this.getInsTagMenu()
  },
  activated() {
    if (!this.isPC) {
      document.documentElement.scrollTop = this.scrollTop
      document.body.scrollTop = this.scrollTop
    }
  },
  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    next()
  },
  computed: {
    getValue() {
      return (code) => {
        let value = ''
        this.deepMenu.forEach(item => {
          if (item.code === code) {
            value = item.value
          }
        })
        return value
      }
    },
    forMatNumber() {
      return (num) => {
        if (Number(num) > 1000000) {
          return `${(Number(num) / 1000000).toFixed(2)}M`
        } else if (Number(num) >= 1000) {
          return `${(num / 1000).toFixed(2)}K`
        } else {
          return num
        }
      }
    },
    upperFirst() {
      return (str) => {
        str = str.toLowerCase()
        return str.replace(/\b\w|\s\w/g, fw => {
          return fw.toUpperCase()
        })
      }
    }

  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },
  watch: {
    selectColor(oldValue, value) {
      this.oldSelectColor = oldValue
    }
  },
  methods: {
    openBlogUrl(e, item) {
      e.stopPropagation()
      window.open(item.blogUrl)
    },
    /* 移动端方法开始 */
    finish() {
    },
    scrollTo() {
    },
    jumpToDetail(item) {
      window.open(`${window.location.origin}/mall/explore/detail?id=${item.blogId}`)
    },
    releaseTimeChangeMobile(value) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      let obj = this.releaseTime.find(item => item.value === value)
      this.$set(this.listForm, 'blogTimeStart', dateFormat(obj.start, 'yyyy-MM-dd'))
      this.$set(this.listForm, 'blogTimeEnd', dateFormat(obj.end, 'yyyy-MM-dd'))
      this.initPage()
    },
    SortChangeMobile(value) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      // let { type } = this.sortType.find(item => item.value === value)
      this.listForm.sortType = value
      this.initPage()
    },
    addMobileFilterTag(item) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      let arr = _.cloneDeep(this.listForm.searchTags)
      arr = arr.includes(item.code) ? arr.filter(a => { return a.code !== item.code }) : [...arr, item.code]
      this.listForm.searchTags = arr
    },
    changeMobileFans(item) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.fansNumber = item.start
      this.$set(this.listForm, 'fansNumStart', item.start)
      this.$set(this.listForm, 'fansNumEnd', item.end)
    },
    submitMobileFilter() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.initPage()
      this.moreFilter = false
    },
    clearAll() {
      this.$set(this.listForm, 'fansNumStart', undefined)
      this.$set(this.listForm, 'fansNumEnd', undefined)
      this.listForm.searchTags = []
      this.fansNumber = ''
      this.initPage()
    },
    /* 移动端方法结束 */
    haspermission() {
      if (!this.$store.state.common.token) {
        this.listForm.searchTags = []
        this.fansNumber = ''
        this.blogTime = ''
        this.fansStart = ''
        this.fansEnd = ''
        this.releaseTimeMobile = ''
        this.sortMobile = 5
        this.$router.push('/login')
        return false
      }
    },
    sortChange(item) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.listForm.sortType = item.value
      this.initPage()
    },
    closeTag(a) {
      this.listForm.searchTags = this.listForm.searchTags.filter(item => item !== a)
      this.getInsList()
    },
    closeTimeTag() {
      this.listForm.blogTimeStart = undefined
      this.listForm.blogTimeEnd = undefined
      this.timetext = ''
      this.blogTime = ''
      this.initPage()
    },
    closeFansTag() {
      this.listForm.fansNumStart = undefined
      this.listForm.fansNumEnd = undefined
      this.fanstext = ''
      this.fansNumber = ''
      this.initPage()
    },
    closeAll() {
      this.listForm.blogTimeStart = undefined
      this.listForm.blogTimeEnd = undefined
      this.listForm.fansNumStart = undefined
      this.listForm.fansNumEnd = undefined
      this.timetext = ''
      this.blogTime = ''
      this.fanstext = ''
      this.fansNumber = ''
      this.listForm.searchTags = []
      this.initPage()
    },
    // 关闭
    closeDialog() {
      this.listForm.searchTags = this.oldSearchTags
      this.categoryVisible = false
      this.areaVisible = false
      this.colorVisible = false
      this.styleVisible = false
      this.designVisible = false
    },
    handleCategoryChange(e, item) {
      this.initPage()
    },
    handleColorChange() {
      this.initPage()
    },
    // 弹窗确定
    checkCategoryFilter() {
      this.listForm.searchTags = [...this.listForm.searchTags, ...this.selectCategorys]
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
      this.closeDialog()
    },
    checkAreaFilter() {
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
      this.closeDialog()
    },
    checkColorFilter() {
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
      this.closeDialog()
    },
    checkStyleFilter() {
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
      this.closeDialog()
    },
    checkElementFilter() {
      this.copyOldElementValue = _.cloneDeep(this.elements)
      let arr = this.elements.map(item => item.active_tag).filter(item => item !== '')
      this.listForm.searchTags = [...this.listForm.searchTags, ...arr]
      this.initPage()
      this.designVisible = false
    },
    openAreaDialog() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.areaVisible = true
    },
    openElementDialog() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.copyOldElementValue = _.cloneDeep(this.elements)
      this.designVisible = true
    },
    opencategoryDialog() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.categoryVisible = true
    },
    openColorDialog() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.colorVisible = true
    },
    openStyleDialog() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.styleVisible = true
    },
    closeElementDialog() {
      this.elements = _.cloneDeep(this.copyOldElementValue)
      this.designVisible = false
    },

    // 国家多选
    handleAreaChange() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
    },
    handleStyleChange() {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.oldSearchTags = _.cloneDeep(this.listForm.searchTags)
      this.initPage()
    },
    handleTimeChange(value, item) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.timetext = item.text
      this.$set(this.listForm, 'blogTimeStart', dateFormat(item.start, 'yyyy-MM-dd'))
      this.$set(this.listForm, 'blogTimeEnd', dateFormat(item.end, 'yyyy-MM-dd'))
      this.initPage()
    },
    handleFansChange(value, item) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.fanstext = item.text
      this.$set(this.listForm, 'fansNumStart', item.start)
      this.$set(this.listForm, 'fansNumEnd', item.end)
      this.initPage()
    },
    initPage() {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      this.listForm.pageNumber = 1
      this.getInsList()
    },
    changeFans(value, type) {
      // if (!this.$store.state.common.token) return this.haspermission() // login
      this.fansNumber = ''
      if (type === 1) {
        this.fansStart = value
        this.$set(this.listForm, 'fansNumStart', Number(value) * 1000)
        if (this.fansEnd === '' || Number(value) * 1000 > this.listForm.fansNumEnd) {
          this.fansEnd = Number(value) + 1
          this.$set(this.listForm, 'fansNumEnd', (Number(value) + 1) * 1000)
        }
      } else {
        if (Number(value) * 1000 < this.listForm.fansNumStart) {
          this.fansEnd = Number(this.fansStart) + 1
          this.$set(this.listForm, 'fansNumEnd', (Number(this.fansStart) + 1) * 1000)
        } else {
          this.$set(this.listForm, 'fansNumEnd', Number(value) * 1000)
        }
      }
      if (this.listForm.fansNumStart && !this.listForm.fansNumEnd) {
        this.fanstext = `≥${this.listForm.fansNumStart}`
      } else if (this.listForm.fansNumEnd && !this.listForm.fansNumStart) {
        this.fanstext = `≤${this.listForm.fansNumEnd}`
      } else if (this.listForm.fansNumStart && this.listForm.fansNumEnd) {
        this.fanstext = `${this.listForm.fansNumStart}-${this.listForm.fansNumEnd}`
      }
      this.fanstext
      if (this.listForm.fansNumStart && this.listForm.fansNumEnd) {
        this.initPage()
      }
    },
    resetForm() {
      this.selectColor = ''
      this.elements.forEach(item => {
        item.active_tag = ''
        item.active_value = ''
        item.active_parentCode = ''
      })
    },

    selectElement(e, item, x) {
      e.stopPropagation()
      item.active_tag = x.code
      item.active_value = x.value
      item.active_parentCode = x.parentCode
    },
    selectArea(code, index) {
      let arr = [...this.listForm.searchTags]
      this.listForm.searchTags = arr.includes(code) ? arr.filter(item => item !== code) : [...this.listForm.searchTags, code]
    },
    colorMouseup(value, index) {
      this.hoverIndex = index
      this.colors.forEach(item => {
        if (item.value === value) {
          this.currentColorSystem = item.childList
        }
      })
    },
    selectColorBar(code) {
      this.selectColor = code
      let arr = [...this.listForm.searchTags]
      this.listForm.searchTags = arr.filter(item => item !== this.oldSelectColor)
      this.listForm.searchTags = [... this.listForm.searchTags, this.selectColor]
    },
    // 获取筛选菜单
    getInsTagMenu() {
      API.getInsTagMenu().then(res => {
        this.menuList = res.data
        let arr = []
        depthTraversal(res.data, item => {
          if (item.code === '品类') {
            this.category = item.childList
          }
          if (item.code === '地区') {
            this.area = item.childList
            this.shortArea = item.childList.slice(0, 4)
          }
          if (item.value === 'clothing design elements') {
            item.childList.forEach(a => {
              if (a.code === '色系') {
                this.colors = a.childList[0].childList
                this.currentColorSystem = this.colors[0].childList
              }
              if (a.code === '风格') {
                this.styles = a.childList
                this.shortStyle = this.styles.slice(0, 6)
              }
              if (a.code !== '色系' && a.code !== '风格') {
                this.$set(a, 'active_tag', '')
                this.$set(a, 'active_value', '')
                this.$set(a, 'active_parentCode', '')
                this.elements.push(a)
              }
            })
          }
          arr.push(item)
        }, 'childList')
        this.deepMenu = arr
      })
    },
    scroll() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight - scrollHeight > -500) {
        this.isBottom = true
        // if (this.isBottom && this.listForm.pageNumber < this.totalPage && this.$store.state.common.token) { // login
        if (this.isBottom && this.listForm.pageNumber < this.totalPage) {
          window.removeEventListener('scroll', this.scroll)
          this.$nextTick(() => {
            this.listForm.pageNumber++
            this.getInsList()
          })
        }
      }
      // if (scrollTop + windowHeight - scrollHeight > -80 && !this.$store.state.common.token) { // login
      //   this.isShow = true
      // } else {
      //   this.isShow = false
      // }
      if (scrollTop >= 260) this.leftFixed = true
      else this.leftFixed = false
    },

    onSwitch(index) {
      this.currentTagsGroup = this.imgBlogList[index]
      this.getTags()
    },

    showDetail(item) {
      this.getInsInfo(item.blogId)
      this.visible = true
      this.drawer = true
      const m = (e) => { e.preventDefault() }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', m, false) // 禁止页面滑动
      let drawer = document.querySelector('.drawer-parent ')
      drawer.style.width = '350px'
      this.$nextTick(() => {
        // this.$refs.imageViwer.deviceSupportUninstall()// 禁止图片滚动放大
        var el = document.querySelector('.image-wrapper')
        if (el) {
          el.style.width = 'calc(100vw - 350px)'
          el.style.maxHeight = '100%'
        }
      })
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_exploreProduct_click`,
        value: JSON.stringify({ blogId: item.blogId })
      })
    },
    closeDrawer() {
      this.drawer = false
      this.visible = false
      this.imgURL = []
      const m = (e) => { e.preventDefault() }
      document.body.style.overflow = 'auto'
      document.removeEventListener('touchmove', m, true)
    },
    getInsInfo(blogId) {
      API.getInsInfo({ blogId: blogId }).then(res => {
        if (res.data.imgBlogList && res.data.imgBlogList.length > 0) {
          this.imgBlogList = res.data.imgBlogList
          this.imgURL = res.data.imgBlogList.map(item => item.imgUrl)
          this.currentTagsGroup = res.data.imgBlogList[0]
          this.getTags()
        }
        this.insInfo = res.data
        this.bloggerObj = res.data.bloggerObj
        let timeStr = new Date(this.bloggerObj.blogTime.split(' ')[0].replace(/-/g, '/')).toDateString()
        let timeArr = timeStr.split(' ')
        let str = `${timeArr[1]} ${timeArr[2]},${timeArr[3]}`
        this.bloggerObj.blogTime = `${this.bloggerObj.blogTime.split(' ')[1]} ${str} `
      })
    },
    getTags() {
      this.currentTagsGroup.boxLabelRetList.forEach(item => {
        item.type1 = []
        item.type2 = []
        item.type3 = []
        item.type4 = []
        item.type5 = []
        item.type6 = []
        item.type7 = []
        item.type8 = []
        item.type9 = []
        item.type10 = []
        item.type11 = []
        item.type12 = []
        item.type13 = []
        item.finalLabelArray.forEach(x => {
          if (x.type === 1) { item.type1.push(x) }
          if (x.type === 2) { item.type2.push(x) }
          if (x.type === 3) { item.type3.push(x) }
          if (x.type === 4) { item.type4.push(x) }
          if (x.type === 5) { item.type5.push(x) }
          // if (x.type === 6) { item.type6.push(x) }
          // if (x.type === 7) { item.type7.push(x) }
          if (x.type === 8) { item.type8.push(x) }
          // if (x.type === 9) { item.type9.push(x) }
          // if (x.type === 10) { item.type10.push(x) }
          if (x.type === 11) { item.type11.push(x) }
          if (x.type === 12) { item.type12.push(x) }
          if (x.type === 13) { item.type13.push(x) }
        }
        )
      })
    },

    getInsList() {
      // this.show_wf = false
      this.listLoading = true
      API.getInsList(this.listForm).then(({ data }) => {
        this.isVisibility = true
        this.totalPage = Math.ceil(data.total / this.listForm.pageSize)
        let resList = _.get(data, 'list', [])
        this.list = this.listForm.pageNumber === 1 ? resList : [...this.list, ...resList]
        this.listLoading = false
      }).finally(() => {
        window.addEventListener('scroll', this.scroll)
        this.listLoading = false
      })
    },
    clickCamera(e, item) {
      e.stopPropagation()
      sessionStorage.removeItem('similar_base64')
      sessionStorage.setItem('similar_img', item.detailUrls)
      this.$nextTick(() => {
        window.open(`${window.location.origin}/mall/similar`)
      })
    },
    clickDetailCamera() {
      // e.stopPropagation()
      sessionStorage.removeItem('similar_base64')
      sessionStorage.setItem('similar_img', this.currentTagsGroup.imgUrl)
      this.$nextTick(() => {
        // this.$router.push('/mall/similar')
        window.open(`${window.location.origin}/mall/similar`)
      })
    },

    getMinColoumHeight(arr) {
      let min = Math.min(...arr)
      return arr.indexOf(min) !== -1 ? arr.indexOf(min) : 0 //  默认第一列
    },
    jump(path, event_id) {
      this.$router.push(path)
    }
  }
}

</script>

<style lang="scss" scoped>
.backtop {
  z-index: 101;
}
.explore {
  max-width: 1410px;
  min-width: 1000px;
  padding: 0 20px;
  margin: 0 auto;
  padding-bottom: 40px;

  .banner {
    width: 100%;
    height: 234px;
    margin: 28px 0;
    img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }
  }

  .left {
    position: absolute;
    width: 250px;
    left: calc((100vw - 1400px) / 2);
    .left-menu {
      overflow: auto;
      height: calc(100vh - 200px);
      padding-left: 27px;
      padding-top: 30px;
      background: #ffffff;
      box-sizing: border-box;
      .menu-item {
        margin-bottom: 35px;
        color: #747a87;
        .menu-item-title {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: #10141d;
          padding-bottom: 12px;
        }
        .view-more {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          cursor: pointer;
        }
      }
    }
    .left-menu::-webkit-scrollbar {
      width: 2px;
    }
    .navigation {
      height: 68px;
    }
  }
  .filter-tag {
    margin-bottom: 15px;
    margin-right: 12px;
    background: #fff;
  }
  .container {
    .register-tip {
      width: 100%;
      height: 45px;
      background: #fff;
      border: 0.5px solid #99c41c;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #10141d;
      margin-bottom: 16px;
      padding-left: 25px;
    }
    .login-cover {
      position: fixed;
      bottom: 0;
      height: 195px;
      width: 100%;
      right: 0;
      z-index: 1000;
      background: linear-gradient(
        252.65deg,
        rgba(246, 246, 246, 0.95) 26.51%,
        rgba(246, 246, 246, 0.96) 58.01%
      );
      p {
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #000000;
        margin-bottom: 20px;
      }
    }
    .filter-box {
      margin-bottom: 15px;

      .sort-type {
        padding: 6px 10px;
        text-align: center;
        color: #747a87;
        border: 0.5px solid #cdd4dd;
        border-radius: 4px;
        background: #ffffff;
        display: inline-block;
        margin-right: 10px;
      }
      .sort-type-select {
        border: none;
        color: #fff;
        background: #99c41c;
      }
    }
    height: calc(100vh - 260px);
    position: relative;
    // top: 68px;
    left: 260px;
    width: calc(100% - 250px);
    .box {
      position: relative;
      .ins-product {
        width: 100%;
        padding: 2%;
        padding-bottom: 20px;
        position: relative;
        z-index: 100;
        .ins-inner {
          height: 100%;
          padding: 12px;
          border-radius: 6px;
          background-color: #fff;
          .ins-product-image {
            position: relative;
            border-radius: 6px;
            img {
              border-radius: 6px;
              width: 100%;
              object-fit: contain;
            }
            .camera {
              display: none;
              position: absolute;
              bottom: 16px;
              left: 12px;
              width: 123px;
              height: 29px;
              color: #fff;
              background: rgba(0, 0, 0, 0.75);
              border-radius: 6px;
              span {
                font-size: 14px;
                font-weight: 300;
                display: inline-block;
                line-height: 29px;
              }
            }
            .camera-normal {
              display: inline-block;
              position: absolute;
              bottom: 16px;
              left: 12px;
              width: 38px;
              height: 29px;
              color: #fff;
              background: rgba(0, 0, 0, 0.75);
              border-radius: 6px;
              span {
                font-size: 14px;
                font-weight: 300;
                display: inline-block;
                line-height: 29px;
              }
            }
            img {
              object-fit: contain;
            }
          }
          .ins-product-image:hover .camera {
            display: block;
          }
          .ins-product-image:hover .camera-normal {
            display: none;
          }
          .info {
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            .avatar {
              display: inline-block;
              margin: 10px 0;
              .head-img {
                position: relative;
                z-index: 666;
              }
              span {
                display: inline-block;
                margin: 0 8px 0 5px;
              }
            }
            .color1 {
              color: #000000;
            }
            .color2 {
              color: #747a87;
            }
            .hot-info {
              margin-bottom: 6px;
              span {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }

  .leftFixed {
    position: fixed;
    top: 150px;
  }

  .category-item {
    margin-bottom: 40px;
    .category-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      width: 90px;
      // min-height: 24px;
    }
    .category-childlist {
      width: calc(100% - 90px);
      padding-left: 5px;
    }
  }
  .color-system-box {
    .color-item {
      .color-quart {
        width: 66px;
        height: 33px;
        margin: 0 8px;
      }
      p {
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #000000;
      }
    }
  }
  .color-system-child {
    .color-child {
      width: 16%;
      .color-bar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin: 15px 35px;
      }
      .selectedColor {
        border: 1px solid #000000;
      }
    }
  }
  .hover {
    width: 83px !important;
    height: 42px !important;
    border: 2px solid #000000;
  }
  /* style */
  .style-box {
    // padding: 0 30px;
    .style-item {
      width: 25%;
      height: 25px;
      margin-bottom: 12px;
      padding-left: 55px;
    }
  }
  .area-box {
    .area-item {
      width: 130px;
      height: 32px;
      background: #ffffff;
      border: 0.5px solid #cdd4dd;
      border-radius: 4px;
      margin: 10px 28px;
      text-align: center;
      line-height: 32px;
    }
    // .active-area {
    //   background: #99c41c!important;
    //   border: none;
    //   color: #fff;
    // }
  }
  .elements {
    margin-bottom: 20px;
    .elements-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
      min-width: 97px;
    }
    .element-tag {
      height: 31px;
      background: #ffffff;
      border: 0.5px solid #cdd4dd;
      border-radius: 4px;
      display: inline-block;
      // line-height: 31px;
      padding: 5px;
      margin-right: 12px;
      margin-bottom: 12px;
      color: #747a87;
      text-align: center;
    }
    .inner-element {
      display: inline-block !important;
      font-weight: 400;
      font-size: 14px;
      margin-right: 40px !important;
      line-height: 21px;
      height: 32px;
      border: 1px solid #000000;
      color: #747a87;
      background: red;
    }
  }
}
.active-area {
  background: #99c41c !important;
  border: none !important;
  color: #fff !important;
}
.blackWhite {
  background-image: linear-gradient(
    90deg,
    rgb(62, 64, 67) 0%,
    rgb(62, 64, 67) 50%,
    rgb(156, 155, 157) 50%,
    rgb(156, 155, 157) 100%
  ) !important;
}
.visibles {
  visibility: visible !important;
}
.columns:nth-child(5) {
  margin-right: 0 !important;
}

.icons {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-bottom: -3px;
  margin-right: 5px;
}
/deep/.el-image-viewer__mask {
  width: calc(100vw - 340px);
  height: 100%;
  overflow: hidden;
}
/deep/.el-dialog__body {
  max-height: 55vh;
  overflow: auto;
}
/deep/.el-radio {
  line-height: 2;
}
/deep/.el-checkbox {
  line-height: 2;
}
/deep/.el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/.el-checkbox__inner {
  width: 16px;
  height: 16px;
}
span {
  display: inline-block;
}
</style>
<style lang="scss" scoped>
.drawer-parent {
  // width: 340px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2009;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding-top: 65px;
  padding-left: 22px;
  padding-right: 20px;
  z-index: 33333333333;
  .bloger {
    margin-bottom: 55px;
    .avatar {
      height: 24px;
      margin-bottom: 30px;
      .info {
        margin-left: 5px;
        line-height: 20px;
        .name {
          font-size: 14px;
          color: #000000;
        }
        .follow {
          font-size: 12px;
        }
      }
    }
    .product-name {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      max-height: 40px;
      margin-bottom: 5px;
      color: #000000;
    }
    .like-comment {
      padding: 15px 0;
    }
    .blog-time {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #747a87;
      margin-bottom: 30px;
    }
  }
  .cloth-detail {
    h1 {
      font-weight: 600;
      font-size: 16px;
      line-height: 23px;
      color: #000000;
      margin-bottom: 30px;
    }
    .elements {
      margin-bottom: 25px;
      .category-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: #000000;
      }
      .elements-item {
        padding-right: 15px;
        margin-bottom: 15px;
        h1 {
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: #000000;
          margin-bottom: 0;
        }
        .element-item-right {
          span {
            display: inline-block;
            margin-left: 5px;
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
            color: #747a87;
          }
        }
      }
    }
  }
}
.drawer-parent::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 1400px) {
  .left {
    left: 15px !important;
  }
}
</style>
<style lang="scss" scoped>
.login-top {
  width: 100vw;
  height: 1rem;
  box-sizing: border-box;
  position: relative;
  // margin-left: -0.3rem;
  background: rgba(13, 16, 22, 0.79);
  color: #fff;
  margin-bottom: 0.2rem;
  padding: 0 0.32rem;
  .login-close {
    width: 0.4rem;
    height: 0.4rem;
    background: #000;
    border-radius: 50%;
    margin-left: 0.24rem;
  }
}
.mobile-explore {
  // background: #fff;
  height: 100vh;
  .mobile-filter-box {
    display: flex;
    position: fixed;
    // top: 0.86rem;
    top: 75px;
    left: 0;
    right: 0;
    z-index: 10;
    /deep/.van-dropdown-menu {
      flex: 2;
    }
    /deep/.van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__title--active {
      color: #99c41c;
    }
    /deep/.van-dropdown-item__option--active {
      color: #99c41c;
    }
    /deep/.van-dropdown-item__option--active .van-dropdown-item__icon {
      color: #99c41c;
    }
    .filter {
      flex: 1;
      line-height: 48px;
      background-color: #fff;
      z-index: 2;
      text-align: center;
      position: relative;
    }
  }
  .mobile-product {
    // margin-top: 1.05rem;
    margin-top: 75px;
    position: relative;
    height: 100vh;
    .mobile-ins-product {
      padding-left: 0.3rem;
      margin: 0;
      padding-top: 0.2rem;
      background-color: #fff;
      padding-bottom: 4rem;
      .ins-inner {
        border-radius: 6px;
        .ins-product-image {
          position: relative;
          border-radius: 6px;
          img {
            border-radius: 6px;
            width: 100%;
            display: block;
            object-fit: contain;
          }
          .head-img {
            position: absolute;
            left: 0.12rem;
            height: 0.12rem;
          }
          .mobile-header {
            position: absolute;
            left: 7px;
            bottom: 10px;
            // z-index: 100;
            img {
              border-radius: 50%;
              width: 24px;
              height: 24px;
            }
          }
        }
        // .ins-product-image:hover .camera {
        //   display: block;
        // }
        // .ins-product-image:hover .camera-normal {
        //   display: none;
        // }
        .info {
          font-weight: 400;
          font-size: 0.26rem;
          line-height: 0.36rem;
          .color1 {
            color: #000000;
          }
          .color2 {
            color: #747a87;
          }
          .hot-info {
            padding-left: 0.1rem;
            span {
              display: inline-block;
            }
            .info-top {
              margin: 0.14rem 0;
            }
            .info-bottom {
              .icons {
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-bottom: -3px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
}
.mobile-filter-content {
  padding: 0.68rem 0 0 0.32rem;
  // position: relative;
  padding-bottom: 2rem;
  overflow: hidden;
  height: 100vh;
  .filter-box {
    height: calc(100vh - 120px);
    // min-height: calc(100vh - 67px);
    overflow: scroll;
    padding-bottom: 1.5rem;
    .mobile-filters {
      width: 100%;
      margin-bottom: 0.4rem;
      h1 {
        font-weight: 500;
        font-size: 0.28rem;
        line-height: 0.42rem;
        color: #10141d;
        padding-bottom: 0.2rem;
      }
      .filter-tag {
        border: 0.5px solid #cdd4dd;
        border-radius: 4px;
        padding: 0.08rem 0.2rem;
        display: inline-block;
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;
      }
    }
  }
  .btns {
    position: absolute;
    background: #fff;
    width: 100%;
    height: 1.34rem;
    border-top: 0.5px solid #f1f1f1;
    left: 0;
    padding: 0 0.4rem;
    bottom: 0;
    .clear-button {
      font-size: 0.28rem;
      line-height: 0.42rem;
      color: #7b7b7b;
    }
  }
  .active-mobile-tag {
    background: #99c41c;
    color: #fff !important;
  }
}
.cell-item {
  width: calc(100% - 0.3rem);
  margin-bottom: 10px;
  background: #ffffff;

  box-sizing: border-box;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.mobile-login-cover {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4rem;
  background: #fff;
  p {
    font-weight: 500;
    font-size: 0.32rem;
    line-height: 0.48rem;
    color: #000000;
    padding-bottom: 0.52rem;
  }
}
</style>
